import html2pdf from 'html2pdf.js';
import ApiService from '../../../service/apiService';
import { convertUTCDateStringToYYYYMMDDHHMMSSFormat } from '../../../HelperMethods/DateUtils';

// eslint-disable-next-line import/prefer-default-export
export async function urlGeneratorForQRCode({
  printIframe,
  qrModalRef,
  documentTitle,
  docId,
  task,
  updatedFormData,
  updatedSignatures,
}) {
  try {
    const taskDetails = {
      taskNumber: task?.taskNumber ?? '',
      taskAsset: task?.asset?.name ?? '',
      startTime: convertUTCDateStringToYYYYMMDDHHMMSSFormat(task.startTime),
      taskName: task?.taskType?.name,
    };
    const document = printIframe.contentDocument;
    if (document) {
      if (qrModalRef?.current?.setModalContent) {
        qrModalRef.current.setModalContent({ loading: true, open: true, taskDetails });
      }
      const html = document.getElementsByTagName('html')[0];
      console.log('html', html);
      const node = html.querySelector('#printFormContainer');
      if (node) {
        node?.classList?.add('pdf-form-container');
      }
      const opts = {
        margin: 10,
        filename: `${documentTitle}.pdf`,
        image: { type: 'jpeg', quality: 0.2 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'p' },
      };
      let promises = [
        html2pdf().set(opts).from(html).outputPdf('blob', `${documentTitle}.pdf`),
        ApiService.getUploadUrlForFileName([{ name: `${documentTitle}.pdf`, id: docId }]),
        ApiService.upsertForm(updatedFormData),
      ];
      if (updatedSignatures && updatedSignatures.length) {
        updatedSignatures = updatedSignatures.map((signatureObject) => ({
          id: updatedFormData.id,
          data: updatedFormData.data,
          signatureObject,
        }));
        const signaturePromise = updatedSignatures.map((signature) => ApiService.updateSignature(signature));
        promises = [...promises, ...signaturePromise];
      }
      const [blob, res] = await Promise.all(promises);
      const [s3Obj] = res;
      const { uploadUrl, attachment } = s3Obj || {};
      const file = new File([blob], `${documentTitle}.pdf`);
      const bodyStream = await file.arrayBuffer();
      await ApiService.uploadFile(uploadUrl, 'application/pdf', bodyStream);
      const signedUrl = await ApiService.getDownloadUrlForS3Key({ s3Key: attachment.key, expires: 86400 });

      if (qrModalRef?.current?.setModalContent) {
        qrModalRef.current.setModalContent({ loading: false, open: true, taskDetails });
      }
      if (qrModalRef?.current?.setQRvalue) {
        qrModalRef.current.setQRvalue(signedUrl);
      }
      if (node) {
        node?.classList?.remove('pdf-form-container');
      }
    }
  } catch (error) {
    if (qrModalRef?.current?.setModalContent) {
      qrModalRef.current.setModalContent({ loading: false, open: false });
    }
    throw new Error('Eroor in generating QR Code');
  }
}
